import { gqlClient } from 'services/api/gql/gqlClient';
import { ProductRecommendations } from 'constants/gql/queries/productRecommendations/productRecommendations.gql';
import localeUtils from 'utils/LanguageLocale';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const getProductRecommendations = async (requestParams = {}) => {
    let client = 'ciojs-client-2.63.0';
    let s = '';
    let id = '';
    const locale = `${localeUtils.getCurrentLanguage().toLowerCase()}-${localeUtils.getCurrentCountry()}`;
    const profileId = Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.profileId || Storage.local.getItem(LOCAL_STORAGE.PROFILE_ID);

    if (window.ConstructorioClient) {
        const { queryParams } = window.ConstructorioTracker.options;
        client = queryParams.c;
        s = queryParams.s;
        id = queryParams.i;
    }

    const options = {
        operationName: 'ProductRecommendations',
        query: ProductRecommendations,
        variables: {
            request: {
                client,
                s,
                id,
                ...(profileId && { ui: profileId }),
                locale,
                userSegments: 'external-app',
                variationsMap: {
                    values: {
                        minListPrice: {
                            aggregation: 'min',
                            field: 'data.currentSku.listPriceFloat'
                        },
                        maxListPrice: {
                            aggregation: 'max',
                            field: 'data.currentSku.listPriceFloat'
                        },
                        minSalePrice: {
                            aggregation: 'min',
                            field: 'data.currentSku.salePriceFloat'
                        },
                        maxSalePrice: {
                            aggregation: 'max',
                            field: 'data.currentSku.salePriceFloat'
                        }
                    },
                    dtype: 'object'
                },
                ...requestParams
            }
        }
    };

    const response = await gqlClient.query(options);

    return response || null;
};

export default getProductRecommendations;
